import selectStyles from "components/olitask/donations/credits/selectStyles";
import React from "react";
import { Col } from "react-bootstrap";
import AsyncSelect from "react-select/async";

export default function UserSelector({users, loading, selectedUser, setSelectedUser}) {

  // Async loader for users
  const loadUsers = async (inputValue) => {
    const filtered = users.filter((u) =>
      `${u.firstName} ${u.lastName} ${u.email}`
        .toLowerCase()
        .includes(inputValue.toLowerCase())
    );

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(
          filtered.map((u) => ({
            value: u.id,
            label: `${u.firstName} ${u.lastName} (${u.email})`,
          }))
        );
      }, 1000);
    });
  };

  return (
    <Col className="col-12">
      <label className="form-label text-xxs mb-0 mb-2">Select User</label>
      <AsyncSelect
        cacheOptions
        defaultOptions={users.map((u) => ({
          value: u.id,
          label: `${u.firstName} ${u.lastName} (${u.email})`,
        }))}
        loadOptions={loadUsers}
        onChange={(opt) => setSelectedUser(opt)}
        value={selectedUser}
        placeholder="Search and select user..."
        isClearable
        isLoading={loading}
        styles={selectStyles}
      />
    </Col>
  );
}
